module.exports = __webpack_public_path__ + "static/media/2024_National Day-sticker.db60d6d2.ai";